export default __webpack_public_path__ + "static/media/Mujer_1.34d47736.svg";